import React, {PureComponent} from "react"

import CompanyBenefitsList from "@irati-web/admin/src/components/Settings/CompanyBenefitsList"
import OptionPicker, {Option} from "../../OptionPicker"
import DefaultMessage from "../DefaultMessage"
import OptionContainerProps from "../sharedProps"
import {isDefaultBenefits, resetBenefits} from "../../../helpers"

interface Props extends OptionContainerProps {}
class Benefits extends PureComponent<Props> {
  handleBenefitChange = (benefits: any[]) => this.props.setIsStepCompletable(benefits.length > 0)

  optionData: Option[] = [
    {
      selectionId: 1,
      title: "setup_tenant.steps.benefits.options.add.title",
      description: "setup_tenant.steps.benefits.options.add.description",
      actionRequiredForStepCompletion: true,
      component: <CompanyBenefitsList hideBannerImageUpload handleBenefitChange={this.handleBenefitChange} minimalView />
    },
    {
      selectionId: 2,
      title: "setup_tenant.steps.benefits.options.noAdd.title",
      description: "setup_tenant.steps.benefits.options.noAdd.description",
      actionRequiredForStepCompletion: false,
      component: <DefaultMessage message="setup_tenant.steps.benefits.options.noAdd.defaultMessage" />
    }
  ]

  render() {
    const {existingSelectionId, handleOptionChange, setIsStepCompletable} = this.props
    return (
      <OptionPicker
        options={this.optionData}
        existingSelectionId={existingSelectionId}
        handleOptionChange={handleOptionChange}
        setIsStepCompletable={setIsStepCompletable}
        areStepSettingsDefault={isDefaultBenefits}
        resetToDefault={resetBenefits} />
    )
  }
}
export default Benefits
